// extracted by mini-css-extract-plugin
export default {"container":"BrandSelection_container__pRCVS","main":"BrandSelection_main__-5XFn"};